import React, { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import Layout from '../components/Layout';

const Welcome = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const horses = [
    {
      name: 'Athena',
      breed: 'Arabisch Volbloed',
      description: '"My once in a life time horse", die van mij de paardenmens gemaakt heeft die ik vandaag de dag ben.',
      image: '/images/athena.jpg',
      link: '/horses/athena'
    },
    {
      name: 'Honey',
      breed: 'Miniatuurpaard',
      description: 'Beter gekend als "Honey The Agility Pony", een klein paardje met een grote missie tot aan de sterren!',
      image: '/images/honey.jpg',
      link: '/horses/honey'
    },
    {
      name: 'Pixie',
      breed: 'Miniatuurpaard',
      description: 'Pixie met de "P" van pittig, de jongedame die me met m\'n voetjes op de grond houdt.',
      image: '/images/pixie.jpg',
      link: '/horses/pixie'
    }
  ];

  const carouselImages = [
    '/images/carousel-1.jpg',
    '/images/carousel-2.jpg',
    '/images/carousel-3.jpg',
    '/images/carousel-4.jpg',
    '/images/carousel-5.jpg',
    '/images/carousel-6.jpg'
  ];

  const nextSlide = useCallback(() => {
    setCurrentSlide((prev) => (prev + 1) % carouselImages.length);
  }, [carouselImages.length]);

  const prevSlide = useCallback(() => {
    setCurrentSlide((prev) => (prev - 1 + carouselImages.length) % carouselImages.length);
  }, [carouselImages.length]);

  useEffect(() => {
    const interval = setInterval(nextSlide, 5000);
    return () => clearInterval(interval);
  }, [nextSlide]);

  const [contactForm, setContactForm] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [contactError, setContactError] = useState('');
  const [contactNotice, setContactNotice] = useState('');

  const handleContactChange = (event) => {
    const { name, value } = event.target;
    setContactError('');
    setContactNotice('');
    setContactForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleContactSubmit = (event) => {
    event.preventDefault();
    if (!contactForm.name || !contactForm.email || !contactForm.message) {
      setContactError('Vul alle verplichte velden in.');
      return;
    }
    const subject = contactForm.subject || 'Bericht via Honey The Agility Pony';
    const body = [
      `Naam: ${contactForm.name || '-'}`,
      `Email: ${contactForm.email || '-'}`,
      '',
      contactForm.message || ''
    ].join('\n');

    setContactNotice('Je mail wordt geopend in je mailprogramma.');
    window.location.href = `mailto:kay.ruymaekers@gmail.com?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  };

  return (
    <Layout
      footerExtra={
        <p className="mt-2 text-sm">
          Alle fantastische media op mijn homepage is dankzij{' '}
          <a
            href="https://www.honderwijs.be/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-400 hover:text-blue-300 transition-colors"
          >
            Kimmy Samoey dierenfotografie
          </a>
          !
        </p>
      }
    >
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-blue-50 to-blue-100 py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">Met trots stel ik aan jullie voor...</h2>
          <div className="max-w-3xl mx-auto mb-8 mt-8">
            <img
              src="/images/hero-image.jpeg"
              alt="Honey The Agility Pony"
              className="rounded-lg shadow-xl w-full h-auto"
            />
          </div>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/leesvoer"
              className="inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-primary hover:bg-primary/90 transition-colors"
            >
              <span className="mr-2">🐴</span>
              Meer info? Klik hier!
            </Link>
            <a
              href="mailto:kay.ruymaekers@gmail.com"
              className="inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-primary hover:bg-primary/90 transition-colors"
            >
              <span className="mr-2">📧</span>
              Contact via email
            </a>
          </div>
        </div>
      </section>

      {/* Book Section */}
      <section className="py-16 bg-white">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-10 items-center">
            <div>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">Ons boek</h2>
              <p className="text-lg text-gray-700 leading-relaxed mb-6 max-w-3xl">
                Horse Agility met Kay &amp; Honey: tips, inspiratie en praktische oefeningen om samen met je paard aan de slag te gaan.
              </p>
              <Link
                to="/leesvoer"
                className="inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-primary hover:bg-primary/90 transition-colors"
              >
                Naar Ons boek
              </Link>
            </div>
            <div className="flex justify-center">
              <Link
                to="/leesvoer"
                className="group block w-full max-w-sm rounded-lg shadow-xl overflow-hidden transition-all duration-200 hover:shadow-2xl hover:-translate-y-1"
                aria-label="Ga naar Ons boek"
              >
                <img
                  src="/images/book-cover.jpg"
                  alt="Horse Agility met Kay & Honey boek"
                  className="w-full h-auto transition-transform duration-300 group-hover:scale-[1.02]"
                />
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* What is Horse Agility Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">Wat is Horse Agility?</h2>
              <p className="text-lg text-gray-700 leading-relaxed mb-6 max-w-3xl">
                Het is niet alleen de ideale sport voor mens en paard die niet kunnen rijden, het is door de variatie en samenwerking ook een meerwaarde voor de band tussen mens en paard te versterken.
              </p>
              <Link
                to="/horse-agility"
                className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-primary hover:bg-primary/90 transition-colors"
              >
                Lees meer!
              </Link>
            </div>
            <div>
              <img
                src="/images/horse-agility.jpg"
                alt="Horse Agility"
                className="rounded-lg shadow-xl w-full h-auto"
              />
            </div>
          </div>
        </div>
      </section>

      {/* My Horses Section */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">Ontmoet mijn toppers</h2>
            <Link to="/mijn-paarden" className="text-primary hover:text-primary/80 transition-colors text-sm font-semibold">
              Bekijk alle paarden
            </Link>
          </div>
          <div className="grid md:grid-cols-3 gap-8">
            {horses.map((horse, index) => (
              <div
                key={index}
                className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow"
              >
                <Link
                  to={horse.link}
                  className="group block overflow-hidden"
                  aria-label={`Ga naar pagina van ${horse.name}`}
                >
                  <img
                    src={horse.image}
                    alt={horse.name}
                    className="w-full h-64 object-cover transition-transform duration-300 group-hover:scale-[1.02]"
                  />
                </Link>
                <div className="p-6">
                  <h4 className="text-2xl font-bold text-gray-900 mb-2">{horse.name}</h4>
                  <h5 className="text-xl font-semibold text-primary mb-4">{horse.breed}</h5>
                  <p className="text-gray-700 mb-4">{horse.description}</p>
                  <Link
                    to={horse.link}
                    className="inline-flex items-center text-primary hover:text-primary/80 font-medium"
                  >
                    <span className="mr-2">🐴</span>
                    Meer over {horse.name}
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Achievements Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <img
                src="/images/achievements.jpg"
                alt="Honey, Pixie & Athena"
                className="rounded-lg shadow-xl w-full h-auto"
              />
            </div>
            <div>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">Reserve Wereldkampioen 2018, 2023 & Europees Kampioen 2019</h2>
              <p className="text-lg text-gray-700 leading-relaxed max-w-3xl">
                Deze mooie prijzen heb ik samen met Honey al in de wacht mogen slepen! Alle maanden nemen we deel aan de competities van The International Horse Agility Club zo blijven we werken aan onze groei als team.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Accredited Trainer Section */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">Accredited Horse Agility Trainer</h2>
              <p className="text-lg text-gray-700 leading-relaxed max-w-3xl">
                Dankzij de mooie resultaten die ik samen met Honey al bereikt heb kreeg ik de kans om gecertificeerd instructeur te worden bij The International Horse Agility Club. Een diploma dat zeldzaam is in de BENELUX.
              </p>
            </div>
            <div className="flex justify-center">
              <img
                src="/images/horse-agility-club-logo.png"
                alt="Horse Agility Club Logo"
                className="rounded-lg"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Image Carousel */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-2xl font-bold text-gray-900 mb-6 text-center">Honey, Pixie & Athena</h2>
          <div className="relative">
            <div className="overflow-hidden rounded-lg shadow-xl">
              <div
                className="flex transition-transform duration-500 ease-in-out"
                style={{ transform: `translateX(-${currentSlide * 100}%)` }}
              >
                {carouselImages.map((image, index) => (
                  <div key={index} className="min-w-full">
                    <img
                      src={image}
                      alt={`Honey, Pixie & Athena ${index + 1}`}
                      className="w-full h-auto"
                    />
                  </div>
                ))}
              </div>
            </div>
            <button
              onClick={prevSlide}
              className="absolute left-4 top-1/2 transform -translate-y-1/2 bg-white bg-opacity-75 hover:bg-opacity-100 rounded-full p-2 shadow-lg transition-all"
              aria-label="Previous slide"
            >
              <svg className="w-6 h-6 text-gray-800" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
              </svg>
            </button>
            <button
              onClick={nextSlide}
              className="absolute right-4 top-1/2 transform -translate-y-1/2 bg-white bg-opacity-75 hover:bg-opacity-100 rounded-full p-2 shadow-lg transition-all"
              aria-label="Next slide"
            >
              <svg className="w-6 h-6 text-gray-800" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </button>
            <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex space-x-2">
              {carouselImages.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentSlide(index)}
                  className={`w-3 h-3 rounded-full transition-all ${
                    index === currentSlide ? 'bg-white' : 'bg-white bg-opacity-50'
                  }`}
                  aria-label={`Go to slide ${index + 1}`}
                />
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contact" className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-12 items-start">
            <div>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">Stuur me een berichtje</h2>
              <p className="text-lg text-gray-700 leading-relaxed mb-6 max-w-3xl">
                Heb je vragen of wil je samenwerken? Stuur gerust een berichtje of mail naar{' '}
                <a href="mailto:kay.ruymaekers@gmail.com" className="text-primary hover:text-primary/80">
                  kay.ruymaekers@gmail.com
                </a>
                .
              </p>
              <form onSubmit={handleContactSubmit} className="space-y-4">
                {contactError ? (
                  <p className="text-sm text-red-600">{contactError}</p>
                ) : null}
                {contactNotice ? (
                  <p className="text-sm text-green-600">{contactNotice}</p>
                ) : null}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1" htmlFor="contact-name">
                    Naam
                  </label>
                  <input
                    id="contact-name"
                    name="name"
                    type="text"
                    value={contactForm.name}
                    onChange={handleContactChange}
                    required
                    className="w-full rounded-md border border-gray-300 px-4 py-2 focus:border-primary focus:ring-primary"
                    placeholder="Voor- en achternaam"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1" htmlFor="contact-email">
                    Email
                  </label>
                  <input
                    id="contact-email"
                    name="email"
                    type="email"
                    value={contactForm.email}
                    onChange={handleContactChange}
                    required
                    className="w-full rounded-md border border-gray-300 px-4 py-2 focus:border-primary focus:ring-primary"
                    placeholder="jij@email.be"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1" htmlFor="contact-subject">
                    Onderwerp
                  </label>
                  <input
                    id="contact-subject"
                    name="subject"
                    type="text"
                    value={contactForm.subject}
                    onChange={handleContactChange}
                    className="w-full rounded-md border border-gray-300 px-4 py-2 focus:border-primary focus:ring-primary"
                    placeholder="Waarover gaat je vraag?"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1" htmlFor="contact-message">
                    Bericht
                  </label>
                  <textarea
                    id="contact-message"
                    name="message"
                    rows="5"
                    value={contactForm.message}
                    onChange={handleContactChange}
                    required
                    className="w-full rounded-md border border-gray-300 px-4 py-2 focus:border-primary focus:ring-primary"
                    placeholder="Schrijf hier je bericht..."
                  ></textarea>
                </div>
                <button
                  type="submit"
                  className="inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-primary hover:bg-primary/90 transition-colors"
                >
                  Verstuur
                </button>
              </form>
            </div>
            <figure className="bg-gray-50 rounded-lg shadow-xl overflow-hidden">
              <img
                src="/images/DSC09620.jpg"
                alt="Honey The Agility Pony"
                className="w-full h-auto"
              />
              <figcaption className="text-sm text-gray-600 px-4 py-3">
                Foto dankzij Margot Mennens.
              </figcaption>
            </figure>
          </div>
        </div>
      </section>

    </Layout>
  );
};

export default Welcome;

